import { render } from "./Assortment.vue?vue&type=template&id=5a6c4a6c&scoped=true"
import script from "./Assortment.vue?vue&type=script&lang=js"
export * from "./Assortment.vue?vue&type=script&lang=js"

import "./Assortment.vue?vue&type=style&index=0&id=5a6c4a6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6c4a6c"]])

export default __exports__